import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { useMenuContext } from '../Menu.Context/index.es.js';
import { useMenuTriggerArrow } from './useMenuTriggerArrow.es.js';

const MenuTrigger = ({ shape = 'square', arrow = 'show', children, className, disabled: propDisabled = false, onClick, ...props })=>{
    const [{ disabled: contextDisabled, open, role }, { setOpen }] = useMenuContext();
    const isDisabled = propDisabled || contextDisabled;
    const arrowIcon = useMenuTriggerArrow({
        colorClass: 'text-icon-neutral'
    });
    const handleClick = useCallback((event)=>{
        if (isDisabled) return;
        event.stopPropagation();
        setOpen(!open);
        onClick?.(event);
    }, [
        open,
        setOpen,
        onClick,
        isDisabled
    ]);
    const handleKeyDown = useCallback((e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(!open);
        }
    }, [
        open,
        setOpen
    ]);
    const handleBlur = useCallback((_event)=>{
        if (open) {
            setOpen(false);
        }
    }, [
        open,
        setOpen
    ]);
    const triggerClassName = classNames('cb-menu-trigger', shape, {
        open,
        disabled: isDisabled
    }, className);
    return jsxs("div", {
        "aria-expanded": open,
        "aria-haspopup": role,
        className: triggerClassName,
        onBlur: handleBlur,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: isDisabled ? -1 : 0,
        ...props,
        children: [
            jsx("div", {
                className: "cb-menu-trigger-content",
                children: children
            }),
            arrow === 'show' && arrowIcon
        ]
    });
};
MenuTrigger.displayName = 'MenuV2.Trigger';

export { MenuTrigger };
//# sourceMappingURL=Menu.Trigger.es.js.map
